import { Injectable } from '@angular/core';
import { DashboardService } from './dashboard.service';

@Injectable({
    providedIn: 'root'
})
export class DcQuoteService {
    private readonly dcQuoteSessionKey = 'dcQuoteData';

    constructor(private readonly dashboardService: DashboardService) { }

    processUserForDcQuoteIfNeeded(): void {
        const isDcQuoteCall = sessionStorage.getItem(this.dcQuoteSessionKey);
        if (isDcQuoteCall) {
           return;
        }
        
        this.processUserForDcQuote();
    }

    processUserForDcQuote(): void {
        const currentDate = new Date();
        const param = { Year: currentDate.getFullYear(), Month: currentDate.getMonth() + 1 };
        this.dashboardService.processUserForDcQuote(param).subscribe({
            next: () => {
                sessionStorage.setItem(this.dcQuoteSessionKey, 'true');
            },
            error: () => {}
        });
    }

    resetDcQuoteFlag(): void {
        sessionStorage.removeItem(this.dcQuoteSessionKey);
    }
}